import { render, staticRenderFns } from "./DistrictTable.vue?vue&type=template&id=702b2cb4"
import script from "./DistrictTable.vue?vue&type=script&lang=js"
export * from "./DistrictTable.vue?vue&type=script&lang=js"
import style0 from "./DistrictTable.vue?vue&type=style&index=0&id=702b2cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports